import { CardBody} from "reactstrap";
import styled from "styled-components";
import LogoImage from '~/assets/img/logo-login.png';
import { color } from "~/assets/styles/colors";

export const Logo = styled.div`
	width: 100%;
	height: 64px;
	background-image: url(${LogoImage});
	background-repeat: no-repeat;
	background-position: center;
	background-size: 225px;
	margin-bottom: 30px;
	@media screen and (max-width: 726px) {
		background-size: 180px;
	}
`;

export const Container = styled.div`
   display: flex;
   align-items: center;
   height: 100vh;
   background-color: ${color.gray};

	.input-token-code{
		text-align: center;
		width: 63px;
		height: 60px;
		margin-right: 5px;
		border: 2px solid #CDCDCD;
	}

   	.content-center{
		display: flex;
		align-items: center;
		flex-direction: column;
		text-align: center;
		p {
			padding: 0px 50px;
		}
   	}

   .esteira{
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		margin: 30px 0px;
		div {
			width: 12px;
			border-radius: 100%;
			height: 12px;
			margin: 10px 5px 0px 5px;
		}
		.complete {
			background-color: ${color.greenMedium};
		}
		.not-complete{
			background-color: ${color.grayMedium};
		}

   }

  	 @media screen and (max-width: 726px) {
		.input-token-code{
			width: 43px;
			height: 70px;
			margin-right: 3px;
		}
	}


	@media screen and (max-width: 366px) {
		.input-token-code{
			width: 33px;
			height: 70px;
		}
	}
`;

export const CardContainer = styled(CardBody)`
	display: flex;
	padding: 0px;
	margin: 0px;
	flex-direction: column;
	align-items: center;
`;

export const TextTitle = styled.div`
	font-weight: bold;
`;

export const TextSubtitle = styled.div`
	margin-top: 30px;
	max-width: 520px;
	text-align: center;
`;
